import { api } from 'api/api'
import { helpersFunc } from 'config/helpers'
import { CONSTS } from 'config/objectConst'
import { appConnector } from 'shared/connector'
import { FatalError, notifyError } from 'shared/errors'

import { appActions, appSelectors } from '../redux/reducers/app'
import store from '../redux/store'
import { app } from './app'

async function setUpInit() {
	const isInstalled = appSelectors.isInstalled(store.getState())
	store.dispatch(appActions.updateInstalled(true))
	if (!isInstalled) {
		return
	}

	const [snailyProfile, linkedInProfile] = await Promise.all([
		connectorAPI.getSnailyProfile(),
		connectorAPI.getLinkedProfile()
	])

	if (snailyProfile && linkedInProfile) {
		const subscription = await api.getSubscription()
		subscription?.data && app.setSubscriptions(subscription?.data)
	}
}

let onGoingSetup = false

export const connectorAPI = {
	getAccessToken: async () => {
		try {
			const result = await appConnector.auth?.getAccessToken()
			return result
		} catch (e) {
			const shouldReload =
				e instanceof Error && e.name === 'ExtensionNotInstalledError'
			if (shouldReload) {
				window.location.reload()
			}

			console.log(e)
			/* you are don't ever loged token error because for logged you needed token - helpersFunc.logEnjectServicePromise(e); */
		}
	},

	getLinkedProfile: async () => {
		try {
			app.setLinkedProfile({
				linkedProfile: {},
				linkedProfileDone: false
			})

			const linkedProfile =
				await appConnector.auth.getAssociatedLinkedInProfile()

			app.setLinkedProfile({
				linkedProfile,
				linkedProfileDone: true
			})
			return linkedProfile
		} catch (error) {
			app.setLinkedProfile({
				linkedProfile: {},
				linkedProfileDone: true
			})

			notifyError(error)
		}
	},

	getSnailyProfile: async () => {
		try {
			const appProfile = await appConnector.auth.getSnailyProfile()
			app.setAppProfile({ appProfile, appProfileDone: true })
			return appProfile
		} catch (error) {
			helpersFunc.logEnjectServicePromise(error)
			//#88 introduce FatalError and throw it here instead of generic Error with Message FATAL ERROR
			throw new FatalError(
				`Unhandled exception occurs during getting ${CONSTS.PROJECT_NAME} profile`
			)
		}
	},

	setUpInit: async () => {
		if (onGoingSetup) {
			return
		}

		onGoingSetup = true
		try {
			await setUpInit()
		} catch (e) {
			console.error(e)
		} finally {
			onGoingSetup = false
		}
	}
}
